import reportTaskTracking from './view/reportTaskTracking.html'

export default {
  base: {
    state: 'declaration.vatDeclarationSurcharges.reportTaskTracking',
    config: {
      url: '/reportTaskTracking',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.vatDeclarationSurcharges.reportTaskTracking.list',
      title: '申报任务跟踪',
    },
  },
  list: {
    state: 'declaration.vatDeclarationSurcharges.reportTaskTracking.list',
    config: {
      url: '/list',
      template: reportTaskTracking,
      controller: 'reportTaskTrackingCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/reportTaskTracking/routers.js